// https://github.com/dmauro/Keypress/blob/master/keypress.coffee#L728-864
// For reference to key names / combos

import Keypress from '../../assets/external_scripts/keypress-2.1.4.min';

const SHIFT = 'shift';
export const CTRL = 'ctrl';
const META = 'meta';

export class KeypressService {
    _listener;
    _modifierState;
    _isDisabled = false;

    constructor() {
        // Keypress.js library, we initialise our main listener here.
        this._listener = new (Keypress as any).Listener();

        // Our modifier state store
        this._modifierState = {};
        this._trackModifier(SHIFT);
        this._trackModifier(CTRL);
        this._trackModifier(META);

        /**
         * This old chestnut is for capturing the state of the modifier keys after the window loses focus
         * Basically there is no way to check their state outside of listening to a KeyboardEvent or MouseEvent.
         * When the window hears the focus event, we register a few listeners in an attempt to capture
         * the very first Keyboard or Mouse. One that listener fires we can check the state of the modifier
         * keys and update our internal state.
         */

        function captureFirstEvent(modifierState) {
            function update(e) {
                modifierState[SHIFT] = e.shiftKey;
                modifierState[CTRL] = e.ctrlKey;
                modifierState[META] = e.metaKey;
            }

            // We use 'capture' on a document listener to make sure it gets the event first, instead of last in the bubbling phase.
            // We use 'once' to automatically clean up the event after it fires once.
            // We use 'passive', because this event is passive.
            const options: any = {
                capture: true,
                once: true,
                passive: true,
            };
            // TODO TS: apparently options has to be a boolean here?
            document.addEventListener('mousemove', update, options);
            document.addEventListener('pointerup', update, options);
            document.addEventListener('click', update, options);
        }

        window.addEventListener('focus', () => captureFirstEvent(this._modifierState));
        window.addEventListener('contextmenu', () => captureFirstEvent(this._modifierState));
    }

    /**
     * This should be private. Making it public for ease of testability.
     * @returns {boolean} True if a text input is focused
     */
    static isTextInputFocused() {
        const activeTagName = document.activeElement.tagName || undefined;
        return ['INPUT', 'TEXTAREA'].includes(activeTagName);
    }

    /**
     * Adds a simple keypress listeners.
     * @param keys keys you wish to register to 'space' or 'ctrl up'
     * @param skipInputs true if we don't want the callback to be fired when an input element has focus
     * @param callback The function to call back when the desired key is pressed
     */
    addSimpleListener(keys, skipInputs, callback) {
        // don't run the call back if the service is disabled
        const toggledCallback = () => {
            if (!this._isDisabled) {
                callback();
            }
            return;
        };

        function checkInputsFirst() {
            // If we want to skip events for inputs, we wrap the callback in a function that does the check first.
            if (!KeypressService.isTextInputFocused()) {
                return toggledCallback();
            }
            return true;
        }
        this._listener.simple_combo(keys, skipInputs ? checkInputsFirst : toggledCallback);
    }

    _trackModifier(key) {
        this._modifierState[key] = undefined;
        this._listener.register_combo({
            keys: key,
            on_keyup: () => {
                this._modifierState[key] = false;
                return true;
            },
            on_keydown: () => {
                this._modifierState[key] = true;
                return true;
            },
        });
    }

    //Checks if the modifier is pressed
    isModifierPressed(modifier) {
        return this._modifierState[modifier];
    }

    disableKeyPresses(): void {
        this._isDisabled = true;
    }

    enableKeyPresses(): void {
        this._isDisabled = false;
    }
}
